module.exports = __webpack_public_path__ + "img/_0.104d538c.png";